/** バージョンの型 */
export type Version = { [key: string]: string };

/** InspeXのリリースバージョン */
export const VERSION: Version = {
  // 2025/10/17 ST1-Round1
  V1: '0.0.1',
  // 2025/11/17 ST1-Round2
  V2: '0.0.2',
  // 2025/12/05 ST1-Round3
  V3: '0.0.3',
  // 2026/01/23 ST2-Round1(Sprint8,9のIT完了時点)
  V4: '0.1.0',
  // 2026/02/20 ST2-Round2
  V5: '0.1.1',
  // 2026/03/10 ST2-Round3
  V6: '0.1.2',
  // 2026/03/25 Sprint10開発
  V7: '0.2.0',
  // 2026/04/10 Sprint10開発(Sprint10のIT1巡目完了時点)
  V8: '0.2.1',
  // 2026/04/17 ST3-プレST(Sprint10のIT完了時点)
  V9: '0.3.0',
  // 2026/04/28 ST3-Round1
  V10: '0.3.1',
  // 2026/05/22 ST3-Round2
  V11: '0.3.2',
  // 2026/05/29 Version1.0 残件開発のIT
  V12: '0.4.0',
  // 2026/06/08 ST3-Round3
  V13: '0.4.1',
  // 2026/06/11 ST3-Round4
  V14: '0.4.2',
  // 2026/06/17 ST3-Round5
  V15: '0.4.3',
  // 2026/06/23 初版 北米リリース
  V16: '1.0.0',
  // 2026/08/13 北米リリース 最終確認会
  V17: '1.0.1',
  /** 現在のバージョン */
  CURRENT: '1.0.1',
};
